export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '学员账号',
    field: 'account',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '学员姓名',
    field: 'fullName'
  },
  /* {
    headerName: '学员身份证',
    field: 'idCard',
  }, */
  {
    headerName: '账号状态',
    field: 'accountState'
  },
  {
    headerName: '任职',
    field: 'userIdentityInfos'
  },
  {
    headerName: '证书名称',
    field: 'certName'
  },
  {
    headerName: '证书分类',
    field: 'category'
  },
  {
    headerName: '证书编码',
    field: 'certCode'
  },
  {
    headerName: '证书获得时间',
    field: 'certDate'
  },
  {
    headerName: '证书最后更新时间',
    field: 'updateTime'
  },
  {
    headerName: '证书类别',
    field: 'type'
  },
  {
    headerName: '是否适用',
    field: 'ifApply'
  }
]
